export enum SurveyState {
    idle = 'idle',
    bootstrap = 'bootstrap',
    loaded = 'loaded',
    started = 'started',
    fetchContent = 'fetchContent',
    fetchQuotas = 'fetchQuotas',
    welcomePage = 'welcomePage',
    bundles = 'bundles',
    updating = 'updating',
    auth = 'auth',
    authCheckVk = 'authCheckVk',
    authCheckPwd = 'authCheckPwd',
    phoneAuth = 'phoneAuth',
    completed = 'completed',
    disabled = 'disabled',
    err404 = 'err404',
    error = 'error',
    blocked = 'blocked',
    retryNotAllowed = 'retryNotAllowed',
    finishing = 'finishing',
    finished = 'finished',
    results = 'results',
    testResults = 'testResults',
}
